export enum EnumCallOutcome {
  audioMessageOnlySuccess = 'SUCCESS_AUDIO_MESSAGE_PLAYED',
  memberCallFailed = 'MEMBER_CALL_FAILED',
  memberHangUp = 'MEMBER_HANG_UP',
  memberMachine = 'MEMBER_VOICEMAIL_ANSWERED',
  targetBusy = 'FAILURE_TARGET_BUSY',
  targetConnected = 'SUCCESS_CONNECTED_TO_TARGET',
  targetMachine = 'SUCCESS_TARGET_VOICEMAIL_ANSWERED',
  targetNotAnswered = 'FAILURE_TARGET_NO_ANSWER',
  targetUnsuccessfulOther = 'FAILURE_TARGET_OTHER',
  voicemailRecordingSuccess = 'SUCCESS_VOICEMAIL_RECORDED',
  unknownStatus = 'UNKNOWN_STATUS'
}

export enum EnumDonationRefType {
  actblue = 'actblue',
  eaContribution = 'eaContribution'
}

export enum EnumFormSubmissionRefType {
  akPage = 'akPage',
  form = 'form',
  formHandler = 'formHandler',
  eaOnlineAction = 'eaOnlineAction',
  mobilizeEvent = 'mobilizeEvent',
  controlShiftPetition = 'controlShiftPetition'
}

export enum EnumEaChangedEntityStatus {
  downloadComplete = 'DOWNLOAD_COMPLETE',
  downloadInProcess = 'DOWNLOAD_IN_PROCESS',
  downloadPending = 'DOWNLOADING_PENDING',
  error = 'ERROR',
  errorRetry = 'ERROR_RETRY',
  exportJobComplete = 'EXPORT_JOB_COMPLETE',
  exportJobInProcess = 'EXPORT_JOB_IN_PROCESS',
  exportJobPending = 'EXPORT_JOB_PENDING'
}

export enum EnumFormType {
  fbLead = 'FB_LEAD',
  form = 'FORM',
  letterCampaign = 'LETTER_CAMPAIGN',
  mobilizeEvent = 'MOBILIZE_EVENT',
  petition = 'PETITION',
  salesforce = 'SALESFORCE'
}

export enum EnumProviderType {
  openMarket = 'openMarket',
  twilio = 'twilio',
  yabbr = 'yabbr'
}

// `app_public.groups.groupable_type` is a plain text column (no DB enum/check
// constraint), so this list is the only source of truth. Adding a value here
// also requires updating:
//   - lib/util/fe/groups.ts: GROUP_TYPE_DISPLAY (TS will error if a case is
//     missing)
//   - lib/util/be/groups.ts: getGroupDependency switch (add a case, even if
//     it's a no-op -- not compiler-enforced, so check it manually)
//   - lib/util/postgraphile/order-by/groups-groupable-type-sort.ts: SQL CASE
//     (falls back to sort=20 if omitted, so a miss is silent -- the parity test
//     in test/lib/util/fe/groups.test.ts catches a mismatch with GROUP_TYPE_DISPLAY)
//   - postgres/function_definitions/app_public/groups_integration_type.js:
//     Postgres fn used for the group list's "integration type" column
//     (returns NULL if omitted, so a miss is silent)
//   - components/pages/campaigns/automations/AutomationAddToGroups.tsx:
//     ALLOWED_GROUPABLE_TYPES -- deliberate subset, decide per type whether
//     it belongs in automations
export enum EnumGroupableType {
  activistCode = 'activistCode',
  actionKit = 'actionKit',
  actionKitActionfield = 'actionKitActionfield',
  actionKitPage = 'actionKitPage',
  actionKitUsergroup = 'actionKitUsergroup',
  controlShiftPetition = 'controlShiftPetition',
  eaCommitteeOptOut = 'eaCommitteeOptOut',
  // Value stays 'sourceCode' to match the existing groups.groupable_type
  // Postgres enum label; only the TS member name is EA-qualified.
  eaSourceCode = 'sourceCode',
  event = 'event',
  form = 'form',
  formHandler = 'formHandler',
  import = 'import',
  keyword = 'keyword',
  simple = 'simple',
  smart = 'smart',
  spam = 'spam',
  mobilizeEvent = 'mobilizeEvent',
  salesforce = 'salesforce',
  onlineAction = 'onlineAction',
  access = 'access'
}

export enum EnumLastMessageDirection {
  incoming = 'incoming',
  outgoing = 'outgoing'
}

export enum EnumLinkTrackLink {
  actblue = 'actblue',
  akPage = 'akPage',
  form = 'form',
  eaContribution = 'eaContribution',
  eaOnlineAction = 'eaOnlineAction',
  mobilize = 'mobilize',
  controlShift = 'controlShift'
}

export enum EnumFlowType {
  texting = 'texting',
  instagram = 'instagram'
}

export enum EnumTriggerAction {
  AbFormExistingMember = 'AB_FORM_EXISTING_MEMBER',
  AbFormNewMember = 'AB_FORM_NEW_MEMBER',
  AbFormUniversal = 'AB_FORM_UNIVERSAL',
  AfterEvent = 'AFTER_EVENT', // unused, remove?
  AkPageExistingMember = 'AK_PAGE_EXISTING_MEMBER',
  AkPageNewMember = 'AK_PAGE_NEW_MEMBER',
  AkPageUniversal = 'AK_PAGE_UNIVERSAL',
  AnFormSubmission = 'AN_FORM_SUBMISSION',
  AnFormSubmissionExistingMember = 'AN_FORM_SUBMISSION_EXISTING_MEMBER',
  AnFormSubmissionNewMember = 'AN_FORM_SUBMISSION_NEW_MEMBER',
  AnLetterCampaignOutreach = 'AN_LETTER_CAMPAIGN_OUTREACH',
  AnLetterCampaignOutreachExistingMember = 'AN_LETTER_CAMPAIGN_OUTREACH_EXISTING_MEMBER',
  AnLetterCampaignOutreachNewMember = 'AN_LETTER_CAMPAIGN_OUTREACH_NEW_MEMBER',
  AnPetitionSubmission = 'AN_PETITION_SUBMISSION',
  AnPetitionSubmissionExistingMember = 'AN_PETITION_SUBMISSION_EXISTING_MEMBER',
  AnPetitionSubmissionNewMember = 'AN_PETITION_SUBMISSION_NEW_MEMBER',
  ApiExistingMemberOnce = 'API_EXISTING_MEMBER_ONCE',
  ApiExistingMemberRepeatable = 'API_EXISTING_MEMBER_REPEATABLE',
  ApiRepeatable = 'API_REPEATABLE',
  ApiRepeatableTwo = 'API_REPEATABLE_TWO', // unused, remove?
  ApiResubscribed = 'API_RESUBSCRIBED',
  ApiSubmission = 'API_SUBMISSION',
  ApiUniversal = 'API_UNIVERSAL',
  BeforeEvent = 'BEFORE_EVENT', // unused, remove?
  ControlShiftDefault = 'CONTROL_SHIFT_DEFAULT',
  ControlShiftSign = 'CONTROL_SHIFT_SIGN',
  ControlShiftSignNewMember = 'CONTROL_SHIFT_SIGN_NEW_MEMBER',
  ControlShiftSignExistingMember = 'CONTROL_SHIFT_SIGN_EXISTING_MEMBER',
  ControlShiftSignConfirm = 'CONTROL_SHIFT_SIGN_CONFIRM',
  ControlShiftSignConfirmNewMember = 'CONTROL_SHIFT_SIGN_CONFIRM_NEW_MEMBER',
  ControlShiftSignConfirmExistingMember = 'CONTROL_SHIFT_SIGN_CONFIRM_EXISTING_MEMBER',
  EventSignup = 'EVENT_SIGNUP',
  FbLeadExistingMember = 'FB_LEAD_EXISTING_MEMBER',
  FbLeadNewMember = 'FB_LEAD_NEW_MEMBER',
  FbLeadSubmission = 'FB_LEAD_SUBMISSION',
  FormHandlerSubmission = 'FORM_HANDLER_SUBMISSION',
  FormHandlerSubmissionExistingMember = 'FORM_HANDLER_SUBMISSION_EXISTING_MEMBER',
  FormHandlerSubmissionNewMember = 'FORM_HANDLER_SUBMISSION_NEW_MEMBER',
  FormSubmission = 'FORM_SUBMISSION', // unused, remove?
  GroupJoinSubscribe = 'GROUP_JOIN_SUBSCRIBE', // unused, remove?
  GroupJoinUniversal = 'GROUP_JOIN_UNIVERSAL', // unused, remove?
  KeywordExistingMember = 'KEYWORD_EXISTING_MEMBER',
  KeywordSubscribe = 'KEYWORD_SUBSCRIBE',
  KeywordUniversal = 'KEYWORD_UNIVERSAL',
  OnlineActionExistingMember = 'ONLINE_ACTION_EXISTING_MEMBER',
  OnlineActionNewMember = 'ONLINE_ACTION_NEW_MEMBER',
  OnlineActionUniversal = 'ONLINE_ACTION_UNIVERSAL',
  Subscribe = 'SUBSCRIBE',
  InstagramCommentAny = 'IG_COMMENT_ANY',
  InstagramCommentPost = 'IG_COMMENT_POST',
  InstagramCommentNext = 'IG_COMMENT_NEXT',
  MobilizeAttend = 'MOBILIZE_ATTEND',
  MobilizeAttendNewMember = 'MOBILIZE_ATTEND_NEW_MEMBER',
  MobilizeAttendExistingMember = 'MOBILIZE_ATTEND_EXISTING_MEMBER',
  MobilizeCancel = 'MOBILIZE_CANCEL',
  MobilizeCancelNewMember = 'MOBILIZE_CANCEL_NEW_MEMBER',
  MobilizeCancelExistingMember = 'MOBILIZE_CANCEL_EXISTING_MEMBER',
  MobilizeConfirm = 'MOBILIZE_CONFIRM',
  MobilizeConfirmNewMember = 'MOBILIZE_CONFIRM_NEW_MEMBER',
  MobilizeConfirmExistingMember = 'MOBILIZE_CONFIRM_EXISTING_MEMBER',
  MobilizeRegister = 'MOBILIZE_REGISTER',
  MobilizeRegisterNewMember = 'MOBILIZE_REGISTER_NEW_MEMBER',
  MobilizeRegisterExistingMember = 'MOBILIZE_REGISTER_EXISTING_MEMBER',
  MobilizeWaitlist = 'MOBILIZE_WAITLIST',
  MobilizeWaitlistNewMember = 'MOBILIZE_WAITLIST_NEW_MEMBER',
  MobilizeWaitlistExistingMember = 'MOBILIZE_WAITLIST_EXISTING_MEMBER'
}

export enum EnumTriggerAudience {
  any = 'any',
  existing = 'existing',
  new = 'new',
  resubscribed = 'resubscribed'
}

export enum EnumTriggerEntity {
  ActionKitPage = 'ActionKitPage',
  Campaign = 'Campaign',
  Event = 'Event',
  Form = 'Form',
  FormHandler = 'FormHandler',
  Group = 'Group',
  Keyword = 'Keyword',
  ControlShift = 'ControlShift',
  ControlShiftPetition = 'ControlShiftPetition',
  MobilizeEvent = 'MobilizeEvent',
  OnlineAction = 'OnlineAction',
  Source = 'Source'
}

export enum EnumZipCodeEntryPromptType {
  all = 'all',
  checkCollect = 'checkCollect',
  new = 'new'
}

export enum EnumOutgoingMessageType {
  Draft = 'draft',
  Test = 'test',
  CannedResponse = 'canned-response',
  AwaitingWinner = 'awaiting_winner'
}
